module.exports = __webpack_public_path__ + "img/Teetueten.d1772257.jpg";